import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SettingsProvider from "../../../../../src/utils/SettingsProvider";
import { ToastContainer } from "react-toastify";
import ToastCloseButton from "../../../../../src/utils/ToastCloseButton";
import GlobalNav from "../../../../../src/components/GlobalNav/GlobalNav";
import Footer from "../../../../../src/components/Footer/Footer";
import EditorSecondaryNav from "../SecondaryNav/EditorSecondaryNav";
import { EditorAppRoutes } from "../AppRoutes/EditorAppRoutes";

export const EditorAppContent = ({ isEmbedded }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language;
  const location = useLocation();
  const isSelectUserTypePage = location.pathname === `/${locale}/login`;

  useEffect(() => {
    document.documentElement.lang = locale;
  }, [locale]);

  return (
    <SettingsProvider id="app" className="app--editor">
      <ToastContainer
        enableMultiContainer
        containerId="top-center"
        position="top-center"
        className="toast--top-center"
        closeButton={ToastCloseButton}
      />

      {!isEmbedded && !isSelectUserTypePage && (
        <>
          <GlobalNav />
          <EditorSecondaryNav />
        </>
      )}

      <EditorAppRoutes />
      <Footer showFeedbackLink />

      <ToastContainer
        enableMultiContainer
        containerId="bottom-center"
        position="bottom-center"
        className="toast--bottom-center"
      />
    </SettingsProvider>
  );
};
